import { Component, Input } from '@angular/core';

@Component({
  template: `
    <div class="ion-padding">
      <h3>{{ header }}</h3>
      <p>{{ text }}</p>
    </div>
  `
})
export class InfoPopoverComponent {
  @Input() header: string = '';
  @Input() text: string = '';
} 